<template>
    <div class="mesin-edc-content">
        <SOSlotBase :container-name="'mesin-detail-content'" :loading="!formReady">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar :page-title="`Detail EDC`" :type="'back'" @back="back" />
                </div>
            </template>

            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>

            <template v-slot:content>
                <div class="p-t-16" v-if="formReady">
                    <div class="detail p-x-20">
                        <div class="m-d-12">
                            <div class="d-grid-12 a-self-center">
                                <p
                                    class="grid-cspan-8 m-d-0 f-18 f-bold f-c-black"
                                    :class="{ 'grid-cspan-12': isActive }"
                                >
                                    {{ detailMesin.nama_mesin_edc }}
                                </p>
                                <div
                                    class="grid-cspan-4 grid-rspan-2 non-active f-12 f-semi j-self-center a-self-center"
                                    v-if="!isActive"
                                >
                                    <label class="m-d-0">
                                        <svg
                                            width="20"
                                            height="21"
                                            viewBox="0 0 20 21"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M10 18C14.1421 18 17.5 14.6421 17.5 10.5C17.5 6.35786 14.1421 3 10 3C5.85786 3 2.5 6.35786 2.5 10.5C2.5 14.6421 5.85786 18 10 18Z"
                                                fill="#964040"
                                            />
                                            <path
                                                d="M10 7.16667V10.5"
                                                stroke="white"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M10 13.8333H10.01"
                                                stroke="white"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                        <span>
                                            Nonaktif
                                        </span>
                                    </label>
                                </div>
                                <p
                                    class="grid-cspan-8 m-d-0 f-13 f-regular f-c-midgrey"
                                    :class="{ 'grid-cspan-12': isActive }"
                                >
                                    Kode Akun {{ detailMesin.idakun_keuangan_mesin_edc }}
                                </p>
                            </div>
                        </div>
                        <div class="section-item settlement b-box m-d-12" v-if="!isNeedConfirm">
                            <div class="f-regular f-c-black">
                                <p class="m-d-0 f-13 f-c-midgrey">Saldo aktif</p>
                                <p class="m-d-0 f-16">{{ detailMesin.saldo | currency }}</p>
                            </div>
                            <div v-if="validateAccess('edc.settlement')">
                                <SOButton
                                    :outline="true"
                                    :text="'Settlement'"
                                    :id="`btn-settlement`"
                                    :disable="detailMesin.saldo === 0"
                                    @action="doAction(`settlement`)"
                                />
                            </div>
                        </div>
                        <div class="b-box konfirmasi" v-if="isNeedConfirm">
                            <div class="section-item">
                                Menunggu konfirmasi settlement {{ saldoSettlement | currency }}
                            </div>
                            <div class="section-item">
                                <div class="f-regular f-c-black">
                                    <div>
                                        <p class="m-d-0 f-13 f-c-midgrey">Saldo aktif</p>
                                        <p class="m-d-0 f-16">{{ detailMesin.saldo | currency }}</p>
                                    </div>
                                </div>
                                <div v-if="validateAccess('edc.settlement')">
                                    <SOButton
                                        :primary="true"
                                        :text="'Konfirmasi'"
                                        :id="`btn-settlement`"
                                        :disable="!isNeedConfirm"
                                        @action="doAction(`konfirmasi`)"
                                        @hook:mounted="doOnMounted"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="separator-line m-d-12" />
                        <div class="f-regular f-14 m-d-12 d-grid-12 f-c-midgrey">
                            <p class="m-d-4 grid-cspan-4">Provider:</p>
                            <p class="m-d-4 grid-cspan-8 f-c-black" v-if="provider">{{ provider.nama }}</p>
                            <p class="m-d-4 grid-cspan-4">Outlet:</p>
                            <p class="m-d-4 grid-cspan-8 f-c-black">{{ detailMesin.nama_outlet }}</p>
                            <p class="m-d-4 grid-cspan-4">Settlement ke:</p>
                            <p class="m-d-4 grid-cspan-8 f-c-black" v-if="rekening">
                                {{ rekening.nama }} - {{ rekening.nomor_rekening }}
                            </p>
                        </div>
                        <div class="separator-line m-d-12" />
                        <div class="m-d-16 f-c-midgrey f-13 f-regular">
                            <p class="m-d-2">Biaya sesama provider: {{ detailMesin.persen_biaya_sesama_provider }}%</p>
                            <p class="m-d-2">Biaya beda provider: {{ detailMesin.persen_biaya_berbeda_provider }}%</p>
                            <p class="m-d-2">Biaya lainnya: {{ detailMesin.persen_biaya_kartu_kredit }}%</p>
                        </div>
                    </div>
                    <div class="separator" />
                    <div class="section-item d-flex-between-center" @click="gotoRiwayatPembayaran" v-if="validateAccess('edc.read')">
                        <div>
                            <p class="m-d-0 f-c-black f-16 f-semi">Riwayat Pembayaran EDC</p>
                            <p class="m-d-0 f-c-midgrey f-14 f-regular">{{ detailMesin.periode_pembayaran_edc }}</p>
                        </div>
                        <div>
                            <img src="../../../assets/icons/chevron_right_4.svg" />
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="section-item d-flex-between-center" @click="gotoRiwayatSettlement" v-if="validateAccess('edc.read')">
                        <div>
                            <p class="m-d-0 f-c-black f-16 f-semi">Riwayat Settlement</p>
                            <p class="m-d-0 f-c-midgrey f-14 f-regular">
                                Terakhir {{ detailMesin.terakhir_settlement }}
                            </p>
                        </div>
                        <div>
                            <img src="../../../assets/icons/chevron_right_4.svg" />
                        </div>
                    </div>
                    <div class="separator" />
                    <div class="d-grid-12 p-x-20 p-y-16" @click="gotoEditMesin" v-if="validateAccess('edc.update')">
                        <div class="grid-cspan-1">
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11 4.5H4C3.46957 4.5 2.96086 4.71071 2.58579 5.08579C2.21071 5.46086 2 5.96957 2 6.5V20.5C2 21.0304 2.21071 21.5391 2.58579 21.9142C2.96086 22.2893 3.46957 22.5 4 22.5H18C18.5304 22.5 19.0391 22.2893 19.4142 21.9142C19.7893 21.5391 20 21.0304 20 20.5V13.5"
                                    stroke="#206CFF"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M18.5 2.99998C18.8978 2.60216 19.4374 2.37866 20 2.37866C20.5626 2.37866 21.1022 2.60216 21.5 2.99998C21.8978 3.39781 22.1213 3.93737 22.1213 4.49998C22.1213 5.06259 21.8978 5.60216 21.5 5.99998L12 15.5L8 16.5L9 12.5L18.5 2.99998Z"
                                    stroke="#206CFF"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <div class="grid-cspan-11 a-self-center">
                            <p class="m-d-0 f-c-black f-16 f-semi">Ubah Data Mesin</p>
                        </div>
                    </div>
                    <div class="separator" />
                    <div class="d-grid-12 p-x-20 p-y-16" @click="toogleMesin" id="toogle-mesin" v-if="validateAccess('edc.update')">
                        <div class="grid-cspan-1">
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M18.36 6.64014C19.6184 7.89893 20.4753 9.50258 20.8223 11.2483C21.1693 12.9941 20.9909 14.8035 20.3096 16.4479C19.6284 18.0923 18.4748 19.4977 16.9948 20.4865C15.5148 21.4753 13.7749 22.0031 11.995 22.0031C10.2151 22.0031 8.47515 21.4753 6.99517 20.4865C5.51519 19.4977 4.36164 18.0923 3.68036 16.4479C2.99909 14.8035 2.82069 12.9941 3.16772 11.2483C3.51475 9.50258 4.37162 7.89893 5.63 6.64014"
                                    :stroke="toogleMesinColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M12 2V12"
                                    :stroke="toogleMesinColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <div class="grid-cspan-11 a-self-center">
                            <p class="m-d-0 f-c-black f-16 f-semi">{{ toogleMesinLabel }}</p>
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="d-grid-12 p-x-20 p-y-16" @click="hapusMesin" v-if="validateAccess('edc.delete')">
                        <div class="grid-cspan-1">
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M3 6.5H5H21"
                                    stroke="#EB5757"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M8 6.5V4.5C8 3.96957 8.21071 3.46086 8.58579 3.08579C8.96086 2.71071 9.46957 2.5 10 2.5H14C14.5304 2.5 15.0391 2.71071 15.4142 3.08579C15.7893 3.46086 16 3.96957 16 4.5V6.5M19 6.5V20.5C19 21.0304 18.7893 21.5391 18.4142 21.9142C18.0391 22.2893 17.5304 22.5 17 22.5H7C6.46957 22.5 5.96086 22.2893 5.58579 21.9142C5.21071 21.5391 5 21.0304 5 20.5V6.5H19Z"
                                    stroke="#EB5757"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M10 11.5V17.5"
                                    stroke="#EB5757"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M14 11.5V17.5"
                                    stroke="#EB5757"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <div class="grid-cspan-11 a-self-center">
                            <p class="m-d-0 f-c-black f-16 f-semi">Hapus Mesin</p>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../store/state";

export default {
    name: "MesinDetail",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOButton,
        SOLoadingPage,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            switch (from.name) {
                case "mesin.edc.list":
                    vm.resetDetailMesin();
                    break;

                case "mesin.edc.detail.delete.invalid":
                case "mesin.edc.detail.delete.confirm":
                case "mesin.edc.detail.switch":
                    vm.viewBtnSwitch();
                    break;
            }

            if (to.name === "mesin.edc.detail") {
                vm.init();
            }
        });
    },
    data() {
        return {
            formReady: false,
        };
    },
    mounted() {
        this.getDetailMesin(this.$route.params.id_mesin);
        this.smartTrackingView("detail_mesin_edc");

    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);
                window.scrollTo(0, 0);
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            response: "response",
            detailMesin: "detailMesin",
        }),
        provider() {
            return this.detailMesin.data_provider;
        },
        isActive() {
            return this.detailMesin.active === 0 ? false : true;
        },
        isNeedConfirm() {
            return this.detailMesin.is_need_settlement;
        },
        saldoSettlement() {
            return !this.isNeedConfirm ? 0 : this.detailMesin.is_need_settlement_data.nominal;
        },
        idSettlement() {
            return !this.isNeedConfirm ? "" : this.detailMesin.is_need_settlement_data.id;
        },
        rekening() {
            return this.detailMesin.rekening_owner;
        },
        toogleMesinLabel() {
            return this.detailMesin.active ? "Nonaktifkan Mesin" : "Aktifkan Mesin";
        },
        toogleMesinColor() {
            return this.detailMesin.active ? "#EB5757" : "#206CFF";
        },
        isDeleteAble() {
            return {
                isValid: this.detailMesin.saldo > 0 || this.detailMesin.is_need_settlement ? false : true,
                isSaldo: !this.detailMesin.is_need_settlement,
            };
        },
    },
    methods: {
        ...mapActions({
            getDetailMesin: `${moduleName}/getDetailMesin`,
            resetDetailMesin: `${moduleName}/resetDetailMesin`,
            resetListMesin: `${moduleName}/resetListMesin`,
        }),
        back() {
            this.$router.push({ name: "mesin.edc.list" });
        },
        doOnMounted() {
            document.getElementById("btn-settlement").style.margin = "0px";
        },
        async init() {
            if (!this.detailMesin.idmesin_edc) {
                await this.setFormReady(false);
                await this.getDetailMesin(this.$route.params.id_mesin);
            }
        },
        gotoRiwayatPembayaran() {
            this.resetListMesin();
            this.$router.push({ name: "mesin.edc.detail.riwayat_pembayaran_edc" });
        },
        gotoRiwayatSettlement() {
            this.resetListMesin();
            this.$router.push({ name: "mesin.edc.detail.settlement.edc" });
        },
        doAction(act) {
            if (act === "konfirmasi") {
                this.$router.push({
                    name: "mesin.edc.detail.setoran",
                    params: { id_settlement: this.idSettlement },
                });
            }
            if (act === "settlement") {
                this.$router.push({
                    name: "mesin.edc.pilih.pembayaran",
                    params: { id_mesin: this.$route.params.id_mesin },
                });
            }
        },
        gotoEditMesin() {
            this.$router.push({ name: "mesin.edc.update", params: { id_mesin: this.detailMesin.idmesin_edc } });
            this.smartTrackingClick("edit_mesin_edc");

        },
        toogleMesin() {
            this.$router.push({ name: "mesin.edc.detail.switch" });
        },
        viewBtnSwitch() {
            document.getElementById("toogle-mesin").scrollIntoView();
        },
        setFormReady(val) {
            this.formReady = val;
        },
        hapusMesin() {
            if (!this.isDeleteAble.isValid) {
                this.$router.push({
                    name: "mesin.edc.detail.delete.invalid",
                    params: { is_saldo: this.isDeleteAble.isSaldo },
                });
            } else {
                this.$router.push({ name: "mesin.edc.detail.delete.confirm" });
            }
            this.smartTrackingClick("hapus_mesin_edc");

        },
    },
};
</script>
<style scoped>
.settlement {
    background: linear-gradient(90deg, #e1ebfe 0%, #ffffff 100%);
}
.konfirmasi {
    background: linear-gradient(90deg, #fff8e1 0%, #ffffff 100%);
}

.konfirmasi .section-item:nth-child(1) {
    padding-bottom: 4px;
    padding-top: 4px;
    color: #c29500;
    border-bottom: 1px solid #ededed;
}

.b-box {
    border: 1px solid #ededed;
    border-radius: 5px;
}
.non-active {
    background-color: #fef0f0;
    margin-top: -10px;
    border-radius: 25px;
    padding: 4px;
    padding-right: 8px;
    max-width: fit-content;
}
.non-active label {
    color: #964040;
}
</style>
